import React from 'react';
import { Link, Meta, Title } from 'react-head';
import { origin } from '../../config';
import { translate } from '../../utils/locale';
import { urlify } from '../../utils/string';

const Top = ({ setup, pageContent = {}, paths, locationType, skipGeneral = false }) => {
	const titlePrefix = translate(setup, 'titlePrefix', 'meta');
	const titleSuffix = translate(setup, 'titleSuffix', 'meta');
	let title = pageContent.metaTitle || pageContent.title || '';
	const tags = {};

	if (!Object.keys(pageContent).length === 0) return null;

	if (paths && Object.keys(paths).length > 1) {
		Object.keys(paths).forEach((lang) => {
			let hrefLang = lang;
			let prefix = `/${lang.toLowerCase()}`;
			if (lang === 'en') {
				hrefLang = 'x-default';
				prefix = '';
			}

			// News exists but is not that page.
			if (paths[lang] && ((paths[lang].indexOf('new-arrivals') !== -1 && paths[lang] !== 'new-arrivals') || (paths[lang].indexOf('nyinkommet') !== -1 && paths[lang] !== 'nyinkommet'))) {
				tags.metaRobots = <Meta key="metaRobots" name="robots" content="noindex" />;
			}
			if (paths[lang] === '' || locationType === 'START' || locationType === 'START2') {
				tags[`linkAlternate${lang}`] = <Link key={`linkAlternate${lang}`} rel="alternate" hrefLang={hrefLang} href={`${origin}${prefix}`} />;
			} else if (!pageContent.restrict || (pageContent.restrict && pageContent.restrict.indexOf(lang) === -1)) {
				tags[`linkAlternate${lang}`] = <Link key={`linkAlternate${lang}`} rel="alternate" hrefLang={hrefLang} href={`${origin}${prefix}/${paths[lang]}`} />;
			}
		});
	}

	Object.keys(pageContent).forEach((tag) => {
		const text = translate(setup, pageContent[tag]);
		if (tag.indexOf('meta') === 0 && text !== '') {
			tags[tag] = <Meta key={tag} name={tag.replace('meta', '').toLowerCase()} content={text} />;
		} else if (tag.indexOf('link') === 0) {
			tags[tag] = <Link key={tag} rel={tag.replace('link', '').toLowerCase()} href={text} />;
		}
	});

	const metaDescription = pageContent.metaDescription ? pageContent.metaDescription : setup.meta.defaultMetaDescription;
	title = `${skipGeneral || titlePrefix === 'titlePrefix' ? '' : `${titlePrefix} `}${translate(setup, title)}${skipGeneral || titleSuffix === 'titleSuffix' ? '' : ` ${titleSuffix}`}`;

	tags['og:type'] = <Meta key="ogType" property="og:type" content="website" />;
	tags['og:title'] = <Meta key="ogTitle" property="og:title" content={title} />;
	tags['og:description'] = <Meta key="ogDescription" property="og:description" content={translate(setup, metaDescription)} />;
	if (pageContent.images) tags['og:image'] = pageContent.images.map((image) => <Meta key={`ogImage-${urlify(image.slice(image.lastIndexOf('/')))}`} name={`ogImage-${urlify(image.slice(image.lastIndexOf('/')))}`} property="og:image" content={image} />);
	if (pageContent.canonical) tags['og:url'] = <Meta key="ogUrl" property="og:url" content={pageContent.canonical} />;

	return (
		<div>
			<Title>{ title }</Title>
			{
				Object.keys(tags).map((tag) => {
					if (tag === 'metaDescription') return <Meta key="metaDescription" name="description" content={translate(setup, metaDescription)} />;
					return tags[tag];
				})
			}
		</div>
	);
};

export default Top;
